import {Injectable} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import { UtilDocumentId } from '@formbird/shared';
import {ComponentDefinition} from '@formbird/types';

@Injectable({
  providedIn: 'root',
})
export class ComponentSetupService {
  constructor(
  ) {
  }

  private formGroups: any = {};

  setupStandardProperties(component: any) {
    const compDef = component.componentDefinition;

    if (compDef) {
      component.disabled = compDef.enabled === false;
    }

    component.elementName = component.fieldName;

    component.registeredControlName = component.fieldName + component.key + UtilDocumentId.generateId();
  }

  /**
   * setup standard component variables. This can be called from the ngOnInit function of a component with:
   * this.componentService.setupStandardComponent(this);
   * @return the responsible control that holds the component value
   */
  setupStandardComponent(component: any, validators?: any) {

    this.setupStandardProperties(component);

    const documentId = component.document.documentId;

    const formGroup = this.ensureFormGroupExisted(documentId);

    const compDef = component.componentDefinition;

    this.setupDefaultValidator(compDef, validators);

    const control = new FormControl({value: component.fieldValue, disabled: this.isComponentDisabled(compDef)}, validators);
    return formGroup.registerControl(component.registeredControlName, control);

  }

  setupControl(component, fieldName, fieldValue, validators?) {

    const formGroup = this.ensureFormGroupExisted(component.document.documentId);

    const control = new FormControl(fieldValue, validators);
    const registeredControlName = fieldName + component.key + UtilDocumentId.generateId();
    return formGroup.registerControl(registeredControlName, control);
  }

  enableField(tplItem, formControl) {
    if (formControl) {
      if (tplItem.enabled === false) {
        formControl.disable({emitEvent: false});
      } else {
        formControl.enable({emitEvent: false});
      }
    }
  }

  enableFieldByFlag(enabled: boolean, formControl) {
    if (formControl) {
      if (enabled === false) {
        formControl.disable({emitEvent: false});
      } else {
        formControl.enable({emitEvent: false});
      }
    }
  }

  private setupDefaultValidator(componentDefinition: ComponentDefinition, validatorOpts?: any) {

    validatorOpts = validatorOpts ? validatorOpts : [];

    if (componentDefinition.mandatory) {
      validatorOpts.push(Validators.required);
    }

  }

  private isComponentDisabled(compDef: ComponentDefinition) {

    return compDef.enabled === false;

  }

  private ensureFormGroupExisted(documentId): FormGroup {

    if (!this.formGroups[documentId]) {
      this.formGroups[documentId] = new FormGroup({});
    }

    return this.formGroups[documentId] as FormGroup;
  }

  getControl(documentId, path) {
    if (this.formGroups[documentId]) {
      const formGroup = this.formGroups[documentId] as FormGroup;
      return formGroup.get(path);
    }
    return null;
  }
}
